import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { EditTable } from '../../../organisms'
import AdminLayoutIndex from '../_layouts'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  reviews: {
    reviews: IJsonResponse
  }
}

const options = { scope: 'activerecord.attributes.review' }
const COLUMNS = [
  {
    name: I18n.t('id', options),
    field: 'id',
  },
  {
    name: I18n.t('post_name', options),
    field: 'post_name',
    renderElement: record => {
      const target = 'review'
      return (
        <a href={`/posts/${record.post_id}`} target="_blank">
          {record.post_name}
        </a>
      )
    },
  },
  {
    name: I18n.t('reviewer_name', options),
    field: 'reviewer_name',
    renderElement: record => {
      if (record.reviewer_id) {
        return (
          <a href={`/admin/users/${record.reviewer_id}/edit`} target="_blank">
            {record.reviewer_name}
          </a>
        )
      }

      if (record.reviewer_id == null) {
        return <span>{record.reviewer_name}</span>
      }
    },
  },
  {
    name: I18n.t('body', options),
    field: 'body',
    renderElement: record => <span>{record.body}</span>,
  },
  ,
  {
    name: I18n.t('rating', options),
    field: 'rating',
    renderElement: record => <span>{record.rating}</span>,
  },
  {
    name: I18n.t('created_at', options),
    field: 'created_at',
  },
]

const Index: React.FC<IProps> = props => {
  const { data, pagination } = adminService.getDataFromJson(props.reviews.reviews)
  const [reviews, setReviews] = React.useState(data)
  const handleClickDelete = record => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(record)
    }
  }
  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await adminService.deleteReview(id)
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setReviews(reviews.filter(review => review.id !== id))
    },
    [reviews]
  )

  return (
    <AdminLayoutIndex
      model="review"
      title={
        <Heading>
          <span>{I18n.t('activerecord.models.review')}</span>
        </Heading>
      }
      main={
        <EditTable
          editable={true}
          columns={COLUMNS}
          records={reviews}
          pagination={pagination}
          handleDelete={handleClickDelete}
        />
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default Index
